// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"LocaleSelector_wrapper__wYNhs","active":"LocaleSelector_active__1t_YE","divider":"LocaleSelector_divider__960gK"};